import React from 'react';
import classnames from 'classnames';
import shortenNumber from '@wix/da-ds/pkg/utils/shortenNumber';
import s from './OverlayControl.scss';
var OverlayControl = function (_a) {
    var title = _a.title, extraStatContent = _a.extraStatContent, stat = _a.stat, children = _a.children, className = _a.className, statClassName = _a.statClassName, _b = _a.showStats, showStats = _b === void 0 ? true : _b, showFlipped = _a.showFlipped;
    return (React.createElement("div", { className: classnames(s['stat'], showFlipped && s['flipped'], className) },
        showStats && (React.createElement("div", { className: classnames(s['stat-number'], statClassName), title: title },
            shortenNumber(stat),
            extraStatContent)),
        children));
};
OverlayControl.displayName = 'OverlayControl';
export default OverlayControl;
//# sourceMappingURL=OverlayControl.js.map